import { FunnelChart, Tooltip, ResponsiveContainer, Funnel, LabelList } from 'recharts';

const LeadFunnelChart = ({ data }: { data: { stage: string; count: number }[] }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <FunnelChart>
        <Tooltip />
        <Funnel dataKey="count" data={data} isAnimationActive>
          <LabelList dataKey="stage" position="right" fill="#000" />
        </Funnel>
      </FunnelChart>
    </ResponsiveContainer>
  );
};

export default LeadFunnelChart;
